import React from "react";
import styles from "./EventItem.module.css"

const EventItem = ({img, title, open}) => {
  return (
    <div className={styles.EventItem} onClick={open}>
      <img src={img} alt={title} className="img-fluid"/>
    </div>
  );
};

export default EventItem;
 